module.exports = __webpack_public_path__ + "static/img/backGround.aa1c65a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/backGround.png
// module id = 8ef0
// module chunks = 1